import api from '@/lib/api';
import type { PaginatedResponse } from '@pms/shared';
import type { EmailLog } from '@/services/api/notifications.api';

export interface GuestsQuery {
  search?: string | undefined;
  isRepeatGuest?: boolean | undefined;
  propertyId?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface GuestIdDocument {
  idType?: string | null;
  idNumber?: string | null;
  idIssuingCountry?: string | null;
  idExpiryDate?: string | null;
}

export interface CreateGuestPayload {
  fullName: string;
  email: string;
  phone?: string | undefined;
  nationality?: string | undefined;
  idType?: string | undefined;
  idNumber?: string | undefined;
  idIssuingCountry?: string | undefined;
  idExpiryDate?: string | undefined;
}

export interface UpdateGuestPayload {
  fullName?: string;
  email?: string;
  phone?: string;
  nationality?: string;
  idType?: string;
  idNumber?: string;
  idIssuingCountry?: string;
  idExpiryDate?: string;
}

export async function fetchGuests(query?: GuestsQuery) {
  const { data } = await api.get('/guests', { params: query });
  return data;
}

export async function fetchGuest(id: string) {
  const { data } = await api.get(`/guests/${id}`);
  return data;
}

export async function createGuest(payload: CreateGuestPayload) {
  const { data } = await api.post('/guests', payload);
  return data;
}

export async function updateGuest(id: string, payload: UpdateGuestPayload) {
  const { data } = await api.patch(`/guests/${id}`, payload);
  return data;
}

export async function fetchGuestBookings(id: string) {
  const { data } = await api.get(`/guests/${id}/bookings`);
  return data;
}

export async function addGuestNote(id: string, note: string) {
  const { data } = await api.post(`/guests/${id}/notes`, { note });
  return data;
}

export interface GuestCommunicationsQuery {
  page?: number;
}

export async function fetchGuestCommunications(
  guestId: string,
  query?: GuestCommunicationsQuery,
): Promise<PaginatedResponse<EmailLog>> {
  const { data } = await api.get<PaginatedResponse<EmailLog>>(
    `/guests/${guestId}/communications`,
    { params: query },
  );
  return data;
}
